module.exports = __webpack_public_path__ + "img/16.78cb9809.png";